import React from 'react'

function BandsList() {
  return (
    <div>BandsList</div>
  )
}

export default BandsList